import { render, staticRenderFns } from "./GoodsForm2.vue?vue&type=template&id=62bb27de&scoped=true&"
import script from "./GoodsForm2.vue?vue&type=script&lang=js&"
export * from "./GoodsForm2.vue?vue&type=script&lang=js&"
import style0 from "./GoodsForm2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GoodsForm2.vue?vue&type=style&index=1&id=62bb27de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bb27de",
  null
  
)

export default component.exports